import WithLink from "features/common/components/WithLink";
import PrimaryButton from "./PrimaryButton";

export default WithLink(PrimaryButton);
